import { Form, Formik } from "formik";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AntTextArea, UploadComment } from "components/Antd";
import { CommonButton, RippleEffect } from "components/UiElement";
import { Link } from "react-router-dom";
import { setSessionStorage } from "utils";
import { useEffect, useState } from "react";
import { validation } from "./validation";

export default function StepFourForm({
  setStep,
  onSubmit,
  isCommentModel,
  isTheme,
  commentData,
  theme,
  subscriptionData,
  loading,
}) {
  const [coverUrl, setCoverUrl] = useState(undefined);
  const [coverLoading, setCoverLoading] = useState(false);

  let initialValues = {
    comment: commentData?.comment || "",
    filePath: commentData?.filePath || "",
  };

  const { t } = useTranslation();

  const ratios = {
    theme01: 1.8,
    theme02: 1,
    theme03: 2.0,
    theme04: 1.76,
  };

  useEffect(() => {
    setCoverUrl(commentData?.filePathUrl);
  }, [commentData]);

  return (
    <>
      <Formik
        initialValues={{ ...initialValues }}
        onSubmit={(val) => {
          if (!coverUrl) {
            val.filePath = "";
          }
          onSubmit(val);
        }}
        validationSchema={validation(coverUrl)}
        enableReinitialize
      >
        {(props) => {
          return (
            <Form>
              <Row>
                <Col md={4} lg={3}>
                  <div className="stepsContent_profile bg-white">
                    {!isCommentModel ? (
                      <h5 className="fw-semibold mb-2 mb-lg-3">
                        {t("text.createMemories.uploadPicturePDF")}
                      </h5>
                    ) : (
                      <h2 className="fw-semibold mb-2 mb-lg-3">
                        {t("text.createMemories.uploadPicturePDF")}
                      </h2>
                    )}
                    <div className="customUpload customUpload-icon customUpload-w100">
                      <UploadComment
                        props={props}
                        filePath={coverUrl}
                        coverUrl={coverUrl}
                        setCoverUrl={setCoverUrl}
                        name="filePath"
                        aspect={ratios?.[theme]}
                        step={4}
                        subscriptionData={subscriptionData}
                        setCoverLoading={setCoverLoading}
                      />
                    </div>
                  </div>
                </Col>

                <Col md={8} lg={9}>
                  <div className="commonCard bg-white">
                    {!isCommentModel && (
                      <div className="commonCard_head">
                        <h2 className="fw-semibold">
                          <span>04</span>
                          {t("text.createMemories.addComment")}
                        </h2>
                      </div>
                    )}

                    <Row className="g-3">
                      <Col xs={12}>
                        <div className="form-group mb-0 customComment">
                          {!isCommentModel ? (
                            <label className="form-label">
                              {t("text.createMemories.comment")}
                            </label>
                          ) : (
                            <h2 className="fw-semibold">
                              {t("text.createMemories.comment")}
                            </h2>
                          )}
                          <AntTextArea
                            className="form-control form-control-textarea textareaCustom textareaCustom-sm"
                            placeholder={t("text.createMemories.typeHere")}
                            setFieldValues={props.handleChange}
                            name="comment"
                            maxLength={250}
                          />
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
              <div className="d-flex align-items-center justify-content-end mt-40">
                <RippleEffect>
                  <Link
                    className="btn btn-light me-2 me-md-3"
                    onClick={(e) => {
                      e.preventDefault();

                      if (isTheme === true) {
                        isCommentModel();
                      } else {
                        setStep(3);
                        setSessionStorage("steps", 3);
                      }
                    }}
                  >
                    {isTheme === true
                      ? t("text.common.close")
                      : t("text.common.goBack")}
                  </Link>
                </RippleEffect>
                <RippleEffect>
                  <CommonButton
                    className="btn btn-danger"
                    type="submit"
                    loading={loading || coverLoading}
                  >
                    {isTheme === true
                      ? t("text.common.send")
                      : t("text.common.next")}
                  </CommonButton>
                </RippleEffect>
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
}
